import React from 'react';

import Align from '@marvelapp/marvel-ui/align';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Link from '@marvelapp/marvel-ui/link';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import assets from 'marketing-website/configs/pages/pricing/assets';

import Image from '../../components/modules/Image';
import Feature from '../../components/modules/Feature';

import OffsetBackground from '../../components/wrappers/OffsetBackground';
import generalStyles from './style/features.module.css';

const features = [
  {
    id: 0,
    image: assets.students,
    title: 'Marvel for Education',
    copy: 'Students and teachers receive 70% off yearly plans. ',
    url:
      'https://help.marvelapp.com/hc/en-us/articles/360003458197-Student-teacher-and-education-discounts',
  },
  {
    id: 1,
    image: assets.nonprofit,
    title: 'Marvel for Non-Profits',
    copy: 'Registered non-profits receive 50% off yearly plans.',
    url:
      'https://help.marvelapp.com/hc/en-us/articles/360003458277-Charity-and-Non-Profit-discounts',
  },
];

export default function Features() {
  return (
    <OffsetBackground height={20}>
      <Spacing size="l" position="bottom" type="padding">
        <PageWrap>
          <div className={generalStyles.container}>
            <Spacing size="xl" position="bottom" type="padding">
              <Grid columns={2} size="xl">
                {features.map(item => (
                  <GridItem key={item.id} columnSpan={2} columnSpanM={1}>
                    <div className={generalStyles.item}>
                      <Image {...item.image} hasShadow={false} />
                      <Spacing sizeМ="l" position="left" type="padding">
                        <Feature
                          copy={item.copy}
                          fontWeight="semibold"
                          title={item.title}
                        />
                        <Align type="center" typeM="left">
                          <Spacing
                            size="xxs"
                            position="topBottom"
                            type="margin"
                          >
                            <Paragraph size="m">
                              <span className="fontWeight-5">
                                <Link
                                  type="blue"
                                  url={item.url}
                                  target="_blank"
                                >
                                  Find out more
                                </Link>
                              </span>
                            </Paragraph>
                          </Spacing>
                        </Align>
                      </Spacing>
                    </div>
                  </GridItem>
                ))}
              </Grid>
            </Spacing>
          </div>
        </PageWrap>
      </Spacing>
    </OffsetBackground>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pricing/Features.js